import React, { createContext, useContext, useEffect } from 'react';

// White theme is now the only theme. This provider still exists so any legacy
// `useTheme()` consumers don't break; theme is always 'light'.
const ThemeContext = createContext({ theme: 'light' });

export const ThemeProvider = ({ children }) => {
    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove('theme-dark');
        root.classList.add('theme-light');
    }, []);

    return (
        <ThemeContext.Provider value={{ theme: 'light' }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
